import React from "react"
import { cn } from "@/lib/utils"

interface EmptyStateProps {
  icon?: React.ReactNode
  title: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center text-center",
        "px-4 py-12 sm:px-6 lg:px-8",
        className,
      )}
    >
      {icon && (
        <div className="text-muted-foreground mb-4 opacity-50 transition-opacity hover:opacity-70">
          {icon}
        </div>
      )}

      <h2 className="text-foreground mb-2 text-2xl font-semibold">{title}</h2>

      {description && (
        <p className="text-muted-foreground mb-6 max-w-md text-base">
          {description}
        </p>
      )}

      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
